import React from 'react';
import PropTypes from 'prop-types';
import { recommendationShape } from '@bibliocommons/bc-prop-types';
import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import { BibSlideContainer } from 'app/components/bibs/shared/BibSlide';

import './RecommendationItem.scss';

export default function RecommendationItem({ item, itemIndex, handleClick }) {
  function renderAttribution() {
    return (
      <div className="provider-label">
        {itemIndex === 0 && <VendorAttributionLabel name={item.get('providerName')} />}
      </div>
    );
  }

  return (
    <BibSlideContainer
      className="cp-bib-recommendation-item"
      metadataId={item.get('id')}
      renderAttribution={renderAttribution}
      handleClick={() => handleClick(item)}
    />
  );
}

RecommendationItem.propTypes = {
  item: recommendationShape.isRequired,
  itemIndex: PropTypes.number.isRequired,
  handleClick: PropTypes.func
};
